var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-193.000000, -1214.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-it-works",
    transform: "translate(0.000000, 980.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups",
    transform: "translate(186.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Collect",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "043-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0143025,7.47644531 L13.7920934,6.44320312 L10.5622124,0 L7.33233147,6.44314453 L0.110062893,7.47638672 L5.33613766,12.4916602 L4.1024505,19.573418 L10.5622124,16.2298828 L17.0219744,19.573418 L15.7882277,12.4917187 L21.0143025,7.47644531 Z M10.5622124,14.2439063 L6.47376757,16.3600781 L7.25460483,11.8780078 L3.94693771,8.70380859 L8.51799,8.04984375 L10.5622124,3.97189453 L12.6064349,8.04978516 L17.1774872,8.70375 L13.8698796,11.8779492 L14.6506573,16.3600781 L10.5622124,14.2439063 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.98f37da622fc5d44d10a493a1402c39c.svg";
export { ForwardRef as ReactComponent };